import React, { useMemo } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';

export interface IProps {
  style?: React.CSSProperties;
  className?: string;
  api: string;
  // 传给子组件的data的key
  dataKey?: string;
  refreshKey?: string;
  interval?: number;
  // 筛选器
  filter?: any;
  children?: React.ReactNode;
  // 额外参数
  extraParams?: any;
  // 指标key
  metricsKeyList?: string[];
  gameInfo: any;
  data?: any;
  formatData?: (data: any) => any;
}

export default function MetricsBreakdownTableService(
  props: IProps,
) {
  const {
    style,
    className,
    api,
    dataKey = 'data',
    refreshKey,
    interval,
    filter,
    children,
    extraParams = {},
    metricsKeyList,
    gameInfo,
    data: propsData,
    formatData,
    ...resetProps
  } = props || {};

  const data = useMemo(() => ({
    edition_unified_id: gameInfo?.edition_unified_id,
    ...(propsData || {}),
    ...(extraParams || {})
  }), [gameInfo?.edition_unified_id, propsData,metricsKeyList, extraParams]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        formatData={formatData}
        refreshKey={refreshKey}
        interval={interval}
        filterLoading={false}
        filterVal={filter}
        beforeRequest={(data) => {
          const { filterVal } = data;
          const { start_time, end_time, date_type, language, game } = filterVal || {};
          const params = {
            unified_id: gameInfo?.edition_unified_id,
            period: date_type,
            start_date: dateTimeFormat(start_time, 'day'),
            end_date: dateTimeFormat(end_time, 'day'),
            filters: {
              unified_edition_id_list: [gameInfo?.edition_unified_id, game],
              language_list: language
            },
            metrics: metricsKeyList || [],
            accumulation: {
              by_unified_edition_id: true,
              by_language: true
            },
            ...(extraParams || {})
          };
          return params;
        }}
        trackData={['edition_unified_id', 'extraParams']}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(resetProps || {}),
            gameInfo,
            filter,
          }),
        )}
      </Service>
    </div>
  );
}
